import AlertPanel from 'components/generic/AlertPanel.component';
import Space from 'components/generic/Space.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './SelfEmployedAlert.module.scss';

export const SelfEmployedAlert = () => {
  const { t } = useTranslation();

  return (
    <div className={CN.component}>
      <AlertPanel tag="SelfEmployedAlert" variant="warning">
        <div className={CN.alertText}>
          <Space bold>{t('onlineBooking.generalSettings.selfEmployedModal.alertImportant')}</Space> {t('onlineBooking.generalSettings.selfEmployedModal.alertDashText')}{' '}
          <Space bold>{t('onlineBooking.generalSettings.selfEmployedModal.alertIndividual')}</Space> {t('onlineBooking.generalSettings.selfEmployedModal.alertTheyMust')}
          <ul className={CN.list}>
            <li className={CN.listItem}>
              {t('onlineBooking.generalSettings.selfEmployedModal.alertUse')} <Space bold>{t('onlineBooking.generalSettings.selfEmployedModal.alertEmail')}</Space>
            </li>

            <li className={CN.listItem}>
              {t('onlineBooking.generalSettings.selfEmployedModal.alertEnter')} <Space bold>{t('onlineBooking.generalSettings.selfEmployedModal.alertBank')}</Space>
            </li>

            <li className={CN.listItem}>
              {t('onlineBooking.generalSettings.selfEmployedModal.alertComplete')} <Space bold>{t('onlineBooking.generalSettings.selfEmployedModal.alertThemselves')}</Space>
            </li>
          </ul>
          {t('onlineBooking.generalSettings.selfEmployedModal.alertMessagePart2Start')} <Space bold>{t('onlineBooking.generalSettings.selfEmployedModal.alertWrongPerson')}</Space>{' '}
          {t('onlineBooking.generalSettings.selfEmployedModal.alertMessagePart2End')}
        </div>
      </AlertPanel>
    </div>
  );
};
